/* eslint-disable */
import { Input, Popper, Typography } from '@material-ui/core'
import Popover from '@material-ui/core/Popover'
import { TypographyProps } from '@material-ui/core/Typography'
import Flex from 'typescript-styled-flex'
import styled, { ITheme } from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

export const SearchPopoverContainer = styled(Popover)<
  IWithSize & { anchorWidth?: number }
>`
  & .MuiPopover-paper {
    max-width: 100%;
    max-height: unset;
    width: ${({ anchorWidth }) => (anchorWidth ? `${anchorWidth}px` : '21em')}
    background-color: white;
    border: none;
    outline: none;
    border-radius: 6px;
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.35);
    margin-top: ${({ size }) => (size ? 9 * size : 9)}px;
    overflow: hidden;
    z-index: 1501;
    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
      margin-top: unset;
      width: 100%;
      border-radius: 0;
    }
  }
`

export const SearchPopperContainer = styled(Popper)<
  IWithSize & { anchorWidth?: number }
>`
  max-width: 100%;
  max-height: unset;
  width: ${({ anchorWidth }) => (anchorWidth ? `${anchorWidth}px` : '21em')};
  background-color: white;
  border: none;
  outline: none;
  border-radius: 6px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.35);
  overflow: hidden;
  z-index: 1501;
  margin-top: ${({ size }) => (size ? 4 * size : 4)}px;
`

export const SummaryBarContainer = styled(Flex as any)<IWithSize>`
  flex-direction: row;
  background-color: ${props => props.theme.colors.palette.paleGrey};
  padding: ${({ size }) =>
    size ? `${6 * size}px ${15 * size}px` : '6px 15px'};
  align-items: center;
  justify-content: space-between;
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    padding: ${({ size }) =>
      size ? `${12 * size}px ${20 * size}px` : '12px 20px'};
  }
`
export const SummaryBarLabel = styled(Typography)<TypographyProps & IWithSize>`
  && {
    font-family: 'Open Sans', sans-serif;
    font-size: ${({ size }) => (size ? 12 * size : 12)}px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.12px;
    text-align: left;
    color: ${(props: ITheme) => props.theme.colors.palette.slateGrey};
  }
`

export const SearchResultsContainer = styled.div`
  overflow-x: hidden;
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    overflow-y: auto;
    max-height: 50vh;
  }
`
export const SearchInputContainer = styled(Flex as any)`
  position: relative;
  justify-content: end;
  width: 100%;
  align-content: center;
  overflow: hidden;
`

export const SearchInputInput = styled(Input)<IWithSize>`
  & input {
    font-size: ${({ size }) => (size ? 14 * size : 14)}px;
    font-family: Montserrat, sans-serif;
    padding: ${({ size }) => (size ? 11 * size : 11)}px
      ${({ size }) => (size ? 45 * size : 45)}px
      ${({ size }) => (size ? 11 * size : 11)}px
      ${({ size }) => (size ? 16 * size : 16)}px;
    color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    & input {
      padding: ${({ size }) =>
        size
          ? `${21 * size}px ${50 * size}px ${21 * size}px ${20 * size}px`
          : '21px 50px 21px 20px'};
      font-size: ${({ size }) => (size ? 16 * size : 16)}px;
    }
  }
`
